module.exports = __webpack_public_path__ + "static/media/uniswap.6d5e8f9c.svg";